import type { User } from "firebase/auth";

/**
 * Resolves whether a signed-in user carries the `admin` custom claim.
 *
 * The claim rides inside the ID token; `getIdTokenResult()` returns the CACHED
 * token, so a freshly-granted claim only appears after a token refresh (sign
 * out/in). Returns false for signed-out users and on any error — the admin UI
 * is gated on a positive result, so failing closed is correct.
 */
export async function readAdminClaim(user: User | null): Promise<boolean> {
  if (!user) return false;
  try {
    const result = await user.getIdTokenResult();
    return result.claims.admin === true;
  } catch {
    return false;
  }
}
